import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Repository from './services/Repository';
import { getProvider } from './vue-apollo';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import '@/assets/css/custom.scss';

// Install BootstrapVue
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
Vue.config.productionTip = false;

Vue.use(Repository);

new Vue({
	apolloProvider: getProvider(),
	router,
	store,
	render: (h) => h(App),
}).$mount('#app');
